import React, { Component } from 'react';
import {} from 'carbon-components-react';
import InspectionWeekHeader from '../../common/InspectionWeekHeader';
import { InspectionWeekBody } from '../../common/InspectionWeekBody';

export class CalendarSkeleton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendar: [
        {
          id: 0,
          name: 'first',
          code: '111',
          inspectionName: 'Fire',
          inspectionType: 'inspectionType',
          division: 'division',
          company: 'company',
          status: 'draft',
          months: [
            {
              idMonths: 1,
              monthName: 'January',
            },
            {
              idMonths: 2,
              monthName: 'February',
            },
            ,
            {
              idMonths: 3,
              monthName: 'March',
            },
            ,
            {
              idMonths: 4,
              monthName: 'April',
            },
          ],
          weeksList: [
            {
              weekNumber: 1,
              numberweekstart: '',
              numberweekend: '4/01',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 2,
              numberweekstart: '5/01',
              numberweekend: '11/01',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 3,
              numberweekstart: '12/01',
              numberweekend: '18/01',
              status: '',
              disabled: true,
            },

            {
              weekNumber: 4,
              numberweekstart: '19/01',
              numberweekend: '25/01',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 5,
              numberweekstart: '26/01',
              numberweekend: '1/02',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 6,
              numberweekstart: '2/02',
              numberweekend: '8/02',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 7,
              numberweekstart: '9/02',
              numberweekend: '15/02',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 8,
              numberweekstart: '16/02',
              numberweekend: '22/02',
              status: '',
              disabled: true,
            },

            {
              weekNumber: 9,
              numberweekstart: '23/02',
              numberweekend: '29/02',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 10,
              numberweekstart: '1/03',
              numberweekend: '7/03',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 11,
              numberweekstart: '8/03',
              numberweekend: '14/03',
              status: '',
              disabled: true,
            },

            {
              weekNumber: 12,
              numberweekstart: '15/03',
              numberweekend: '21/03',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 13,
              numberweekstart: '12/03',
              numberweekend: '28/03',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 14,
              numberweekstart: '29/03',
              numberweekend: '4/04',
              status: '',
              disabled: true,
            },
            {
              weekNumber: 15,
              numberweekstart: '05/04',
              numberweekend: '11/04',
              status: '',
              disabled: true,
            },

            {
              weekNumber: 16,
              numberweekstart: '12/04',
              numberweekend: '18/04',
              status: '',
              disabled: true,
            },

            {
              weekNumber: 17,
              numberweekstart: '19/04',
              numberweekend: '25/04',
              status: '',
              disabled: true,
            },

            {
              weekNumber: 18,
              numberweekstart: '26/04',
              numberweekend: '02/05',
              status: '',
              disabled: true,
            },
          ],
        },
        {
          id: 1,
          name: 'second',
          code: '112',
          inspectionName: 'Fire',
          inspectionType: 'inspectionType',
          division: 'division',
          company: 'company',
          status: 'draft',
          months: [
            {
              idMonths: 1,
              monthName: 'May',
            },
            {
              idMonths: 2,
              monthName: 'June',
            },
            ,
            {
              idMonths: 3,
              monthName: 'July',
            },
            ,
            {
              idMonths: 4,
              monthName: 'August',
            },
          ],
          weeksList: [
            {
              weekNumber: 19,
              numberweekstart: '03/05',
              numberweekend: '09/05',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 20,
              numberweekstart: '10/05',
              numberweekend: '16/05',
              status: '2',
              disabled: true,
            },
            {
              weekNumber: 21,
              numberweekstart: '17/05',
              numberweekend: '23/05',
              status: '1',
              disabled: true,
            },

            {
              weekNumber: 22,
              numberweekstart: '24/05',
              numberweekend: '30/05',
              status: '3',
              disabled: true,
            },
            {
              weekNumber: 23,
              numberweekstart: '31/05',
              numberweekend: '06/06',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 24,
              numberweekstart: '07/06',
              numberweekend: '13/06',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 25,
              numberweekstart: '14/06',
              numberweekend: '20/06',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 26,
              numberweekstart: '21/06',
              numberweekend: '27/06',
              status: '0',
              disabled: true,
            },

            {
              weekNumber: 27,
              numberweekstart: '28/06',
              numberweekend: '04/07',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 28,
              numberweekstart: '05/07',
              numberweekend: '11/07',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 29,
              numberweekstart: '12/07',
              numberweekend: '18/07',
              status: '1',
              disabled: true,
            },

            {
              weekNumber: 30,
              numberweekstart: '19/07',
              numberweekend: '25/07',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 31,
              numberweekstart: '26/07',
              numberweekend: '01/08',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 32,
              numberweekstart: '02/08',
              numberweekend: '08/08',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 33,
              numberweekstart: '09/08',
              numberweekend: '15/08',
              status: '0',
              disabled: true,
            },

            {
              weekNumber: 34,
              numberweekstart: '16/08',
              numberweekend: '22/08',
              status: '0',
              disabled: true,
            },

            {
              weekNumber: 35,
              numberweekstart: '23/08',
              numberweekend: '29/08',
              status: '0',
              disabled: true,
            },

            {
              weekNumber: 36,
              numberweekstart: '30/08',
              numberweekend: '05/09',
              status: '0',
              disabled: true,
            },
          ],
        },
        {
          id: 3,
          name: 'terz',
          code: '114',
          inspectionName: 'Fire',
          inspectionType: 'inspectionType',
          division: 'division',
          company: 'company',
          status: 'draft',
          months: [
            {
              idMonths: 1,
              monthName: 'September',
            },
            {
              idMonths: 2,
              monthName: 'October',
            },
            ,
            {
              idMonths: 3,
              monthName: 'November',
            },
            ,
            {
              idMonths: 4,
              monthName: 'December',
            },
          ],
          weeksList: [
            {
              weekNumber: 37,
              numberweekstart: '06/09',
              numberweekend: '12/09',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 38,
              numberweekstart: '13/09',
              numberweekend: '19/09',
              status: '2',
              disabled: true,
            },
            {
              weekNumber: 39,
              numberweekstart: '20/09',
              numberweekend: '26/09',
              status: '1',
              disabled: true,
            },

            {
              weekNumber: 40,
              numberweekstart: '27/09',
              numberweekend: '03/10',
              status: '3',
              disabled: true,
            },
            {
              weekNumber: 41,
              numberweekstart: '04/10',
              numberweekend: '10/10',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 42,
              numberweekstart: '11/10',
              numberweekend: '17/10',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 43,
              numberweekstart: '18/10',
              numberweekend: '24/10',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 44,
              numberweekstart: '25/10',
              numberweekend: '31/10',
              status: '',
              disabled: true,
            },

            {
              weekNumber: 45,
              numberweekstart: '01/11',
              numberweekend: '07/11',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 46,
              numberweekstart: '08/11',
              numberweekend: '14/11',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 47,
              numberweekstart: '15/11',
              numberweekend: '21/11',
              status: '1',
              disabled: true,
            },

            {
              weekNumber: 48,
              numberweekstart: '22/11',
              numberweekend: '28/11',
              status: '1',
              disabled: true,
            },
            {
              weekNumber: 49,
              numberweekstart: '29/11',
              numberweekend: '05/12',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 50,
              numberweekstart: '06/12',
              numberweekend: '12/12',
              status: '0',
              disabled: true,
            },
            {
              weekNumber: 51,
              numberweekstart: '13/12',
              numberweekend: '19/12',
              status: '0',
              disabled: true,
            },

            {
              weekNumber: 52,
              numberweekstart: '20/12',
              numberweekend: '26/12',
              status: '0',
              disabled: true,
            },

            {
              weekNumber: 53,
              numberweekstart: '27/12',
              numberweekend: '02/01',
              status: '0',
              disabled: true,
            },
          ],
        },
      ],
    };
  }

  render() {
    return this.state.calendar.map((formonth) => (
      <>
        <tr className="fist-row-header ">
          {formonth.months.map((month) => (
            <th
              colSpan="5"
              key={month.monthName}
              className={
                month.selected
                  ? 'box-information-tilte-description headerSelected'
                  : 'box-information-tilte-description'
              }
            >
              {month.monthName}
            </th>
          ))}
        </tr>
        <tr className="second-row-header">
          {formonth.weeksList.map((week) => (
            <th colSpan="1" key={week.weekNumber} id={`row_${week.weekNumber}`}>
              <InspectionWeekHeader
                numberweek={week.weekNumber}
                numberweekstart={'01/01'}
                numberweekend={'12/12'}
              />
            </th>
          ))}
        </tr>
        <tr className="table-row-drill" id={`row_${formonth.weekNumber}`}>
          {formonth.weeksList.map((week) => (
            <td colSpan="1" key={`row_${week.weekNumber}`} id={`row_${week.weekNumber}`}>
              <InspectionWeekBody
                keyweek={week.weekNumber}
                draft={0}
                approved={0}
                submit={0}
                planned={0}
              />
            </td>
          ))}
        </tr>
      </>
    ));
  }
}
